module.exports = __webpack_public_path__ + "assets/images/01_active_aafb534b46a9c01d7ec2dd50859612f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01_active.png
// module id = 166
// module chunks = 0